import WorkoutsPageState from "interfaces/WorkoutsPageState";
import { SortOrder } from "../../interfaces/SortOrder";
import {
  SET_HORSE_NAME,
  SET_IS_CONDENSED_VIEW,
  SET_PAGE,
  SET_SCHEDULED_DATES_ONLY,
  SET_SEARCH_VALUE,
  SET_SELECTED_FACILITY,
  SET_SELECTED_HORSE_ID,
  SET_SHOULD_SCROLL_SYNC,
  SET_SHOW_WEATHER,
  SET_SORT_ORDER,
  SET_WEATHER_HEIGHT,
  WorkoutsPageType
} from "store/actions/workoutsPage";

const initialState: WorkoutsPageState = {
  shouldScrollSync: true,
  scheduledDatesOnly: false,
  isCondensedView: false,
  horseName: "",
  selectedFacility: null,
  selectedHorseId: "",
  page: 1,
  showWeather: true,
  weatherHeight: 0,
  sortOrder: SortOrder.ASC,
  searchValue: ""
};

export default (
  state = initialState,
  action: WorkoutsPageType
): WorkoutsPageState => {
  switch (action.type) {
    case SET_SELECTED_FACILITY:
      return {
        ...state,
        selectedFacility: action.selectedFacility
      };
    case SET_IS_CONDENSED_VIEW:
      return {
        ...state,
        isCondensedView: action.isCondensedView
      };
    case SET_SCHEDULED_DATES_ONLY:
      return {
        ...state,
        scheduledDatesOnly: action.scheduledDatesOnly
      };
    case SET_HORSE_NAME:
      return {
        ...state,
        horseName: action.horseName
      };
    case SET_SHOULD_SCROLL_SYNC:
      return {
        ...state,
        shouldScrollSync: action.shouldScrollSync
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.page
      };
    case SET_SHOW_WEATHER:
      return {
        ...state,
        showWeather: action.showWeather
      };
    case SET_SELECTED_HORSE_ID:
      return {
        ...state,
        selectedHorseId: action.selectedHorseId
      };
    case SET_WEATHER_HEIGHT:
      return {
        ...state,
        weatherHeight: action.weatherHeight
      };
    case SET_SORT_ORDER:
      return {
        ...state,
        sortOrder: action.sortOrder
      };
    case SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue
      };
    default:
      return state;
  }
};
